import { Container } from '@mui/material';
import { HeadCell, Loader, SimpleTable, TitlePanels, usePagination } from '@shared';
import { ColumnsIdsIncompleteAuditsTable } from './IncompleteAudits.types';
import { IncompleteAuditsTableCells } from './IncompleteAuditsTableCells';
import { useIncompleteAudits } from './useIncompleteAudits';

const headCellsAuditQueueTable: readonly HeadCell<ColumnsIdsIncompleteAuditsTable>[] = [
  {
    id: 'audit start',
    label: 'Audit Start',
  },
  {
    id: 'auditor',
    label: 'Auditor',
  },
  {
    id: 'partner',
    label: 'Partner',
  },
  {
    id: 'exam start',
    label: 'Exam Start Time',
  },
  {
    id: 'exam end',
    label: 'Exam End Time',
  },
  {
    id: 'anomaly count',
    label: 'Anomalies',
  },
  {
    id: 'audit button',
    label: '',
  },
];
const LIMIT = 20;

export function IncompleteAudits() {
  const [page, setPage] = usePagination();
  const { data, isError, isFetching, isLoading } = useIncompleteAudits(page);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }

  const { totalResults, compositeAudits } = data;

  const pagination = totalResults > compositeAudits.length;
  const totalPages = pagination ? Math.ceil(totalResults / LIMIT) : undefined;

  return (
    <Container component='article'>
      <TitlePanels titles={['Incomplete Audit Queue']} counter={totalResults} />
      <SimpleTable
        columns={headCellsAuditQueueTable}
        rows={compositeAudits}
        entityName={'audit'}
        pagination={pagination}
        totalPages={totalPages}
        onPageChange={setPage}
        isLoading={isFetching}
        renderElems={(session) => <IncompleteAuditsTableCells {...session} />}
      />
    </Container>
  );
}
